import type { GameId, SpinRequest, SpinResponse } from '@sss/shared'
import { HttpClient } from '@/net/HttpClient'
import { AuthService } from '@/net/AuthService'
import { EventBus } from '@/net/EventBus'

export const SpinService = {
  async spin(args: {
    game_id: GameId
    bet_amount: number
    boost?: boolean
    room_id?: string | null
  }): Promise<SpinResponse> {
    await AuthService.ensure()
    const body: SpinRequest = {
      client_request_id: HttpClient.newRequestId(),
      game_id: args.game_id,
      room_id: args.room_id ?? null,
      bet_amount: args.bet_amount,
      boost: args.boost ?? false,
    }
    EventBus.emit('spin:start', {
      client_request_id: body.client_request_id,
      bet: body.bet_amount,
    })
    try {
      const res = await HttpClient.post<SpinResponse>('/api/v1/spins', body)
      EventBus.emit('spin:settled', { spin_id: res.spin_id, total_win: res.total_win })
      EventBus.emit('wallet:changed', { balance: res.wallet_balance_after })
      return res
    } catch (err) {
      const msg = err instanceof Error ? err.message : String(err)
      EventBus.emit('spin:error', { message: msg })
      throw err
    }
  },
}
